<template>
    <SliderRoot
        v-model="internalValue"
        :min="min"
        :max="max"
        :step="step"
        class="slider-container relative flex h-7 w-full items-center select-none"
    >
        <SliderTrack class="diagonal-edges relative h-2 w-full grow overflow-hidden bg-zinc-700">
            <SliderRange class="absolute h-full bg-linear-to-r from-red-500 to-red-700" />
        </SliderTrack>
        <SliderThumb
            class="clip-diagonal-corners-small slider-thumb relative block size-7 cursor-pointer bg-red-700"
            :aria-label="$t('game_explanation.difficulty')"
            ><div class="clip-diagonal-corners-small absolute inset-0.5 bg-zinc-900"></div
        ></SliderThumb>
    </SliderRoot>
</template>

<script>
import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from 'reka-ui'

export default {
    name: 'CustomSlider',
    components: {
        SliderRoot,
        SliderTrack,
        SliderRange,
        SliderThumb,
    },
    props: {
        modelValue: {
            type: [Number, Array],
            default: 0,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        step: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        internalValue: {
            get() {
                return Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue]
            },
            set(value) {
                this.$emit('update:modelValue', Array.isArray(this.modelValue) ? value : value[0])
            },
        },
    },
}
</script>

<style>
.diagonal-edges {
    clip-path: polygon(0.5rem 0%, 100% 0%, calc(100% - 0.5rem) 100%, 0% 100%);
}

.slider-container {
    touch-action: pan-x;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
}

.slider-thumb {
    touch-action: none;
    -webkit-tap-highlight-color: transparent;
}
</style>
